// Utility function for generating URL-friendly slugs
export const generateSlug = (title) => {
    return title
        .toLowerCase()
        // Remove special characters except spaces and hyphens
        .replace(/[^\w\s-]/g, '')
        // Replace spaces with hyphens
        .replace(/\s+/g, '-')
        // Remove multiple consecutive hyphens
        .replace(/-+/g, '-')
        // Remove leading/trailing hyphens
        .trim()
        .replace(/^-+|-+$/g, '');
};
// Check if slug is unique
export const isSlugUnique = async (slug, table = 'posts', excludeId) => {
    const { supabase } = await import('@/lib/supabase');
    let query = supabase
        .from(table)
        .select('id')
        .eq('slug', slug);
    if (excludeId) {
        query = query.neq('id', excludeId);
    }
    const { data, error } = await query;
    if (error) {
        console.error('Error checking slug uniqueness:', error);
        return false;
    }
    return data.length === 0;
};
// Generate unique slug by appending numbers if needed
export const generateUniqueSlug = async (title, table = 'posts', excludeId) => {
    let baseSlug = generateSlug(title);
    let slug = baseSlug;
    let counter = 1;
    while (!(await isSlugUnique(slug, table, excludeId))) {
        slug = `${baseSlug}-${counter}`;
        counter++;
    }
    return slug;
};
